import React from 'react'
import { useTranslation } from 'react-i18next'
import {Grid, Typography} from 'antd'
import {useInjection} from 'dna-react-ioc'
import {Button} from '@/components/dumb/Button'
import {ModalContainer} from '@/components/containers'
import {TModalContainerStore} from '@/components/containers/ModalContainer/TModalContainerStore'
import {ConfirmationModalProps} from './props'
import {CANCEL_CONFIRMATION_BUTTON, SUBMIT_CONFIRM_EMAIL} from '@/constants/playwright-ids'

const {Text} = Typography
const {useBreakpoint} = Grid

export const ConfirmationModal = ({children, modalStoreSymbol, open}: ConfirmationModalProps) => {
    const { t } = useTranslation()
    const screens = useBreakpoint()
    const isMobile = screens.xs
    const store = useInjection<TModalContainerStore>(modalStoreSymbol)

    return (
        <ModalContainer
            injectableIdentifier={modalStoreSymbol}
            open={open}
            title={t('ConfirmationModal.chargeConfirmation')}
            footer={[
                !isMobile && (
                    <Button
                        role={'cancel-button'}
                        ghost
                        key={'cancel'}
                        onClick={store?.onCancel}
                        data-test-id={CANCEL_CONFIRMATION_BUTTON}
                    >
                        {t('ConfirmationModal.cancel')}
                    </Button>
                ),
                <Button
                    type={'primary'}
                    key={'charge'}
                    onClick={store?.onCancel}
                    data-test-id={SUBMIT_CONFIRM_EMAIL}
                >
                    {t('ConfirmationModal.confirm')}
                </Button>
            ]}
        >
            <Text>{t('ConfirmationModal.confirmationText', { amount: children })}</Text>
        </ModalContainer>
    )
}
